module.exports = __webpack_public_path__ + "img/Hamburguer.8148afb3.png";